module.exports = __webpack_public_path__ + "img/female_teacher.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatars/woman/female_teacher.svg
// module id = 482
// module chunks = 0